export const capitalize = (str: string) => {
  const first = str.slice(0, 1).toUpperCase();
  const rest = str.slice(1).toLowerCase();
  return `${first}${rest}`;
};
